import { z } from "zod";

/**
 * ReportMonitoramentoChecklistSchema
 */

export const ReportMonitoramentoChecklistSchema = z.object({
  area: z.array(z.number()).nullable().default(null),
  statusArea: z.array(z.number()).nullable().default(null),
  servico: z.array(z.number()).nullable().default(null),
  statusServico: z.array(z.number()).nullable().default(null),
  dataAberturaDe: z.coerce.date().nullable().default(null),
  dataAberturaAte: z.coerce.date().nullable().default(null),
  dataEncerramentoDe: z.coerce.date().nullable().default(null),
  dataEncerramentoAte: z.coerce.date().nullable().default(null),
  statusVerificacao: z.array(z.number()).nullable().default(null),
  statusItemChecklist: z.array(z.number()).nullable().default(null),
  empresaTercerizada: z.array(z.number()).nullable().default(null),
  funcionarios: z.array(z.number()).nullable().default(null),
});

/**
 * ReportMonitoramentoChecklistForm
 */

export type ReportMonitoramentoChecklistForm = z.infer<typeof ReportMonitoramentoChecklistSchema>;